<template>
  <div class="race" v-if="isLoaded">
    <van-nav-bar
      title="赛事详情"
      left-text=""
      right-text=""
      left-arrow
      @click-left="backToExplore"
    />

    <div class="header bgwhite">
      <img class="cover" v-lazy="race.cover_url">
      <div class="info" style="margin-bottom: 10px;">
        <div class="title">
          <span>{{ race.name }}</span>
        </div>
        <div class="subinfo">
          <div style="margin-bottom: 2px;">
            赛事时间：{{ race.start_time }} ～ {{ race.end_time }}
          </div>
          <div style="margin-bottom: 2px;">赛事距离：{{ distanceList(race.rules) }}</div>
          <div style="margin-bottom: 2px;">报名时间：{{ race.sign_start_time }} ～ {{ race.sign_end_time }}</div>
          <div style="margin-bottom: 2px;">已报名：{{ race.user_num }}人</div>
        </div>
      </div>
    </div>

    <div class="race_detail">赛事介绍</div>

    <div class="clazz_part render-html">
      <div v-html="race.intro_html"></div>
      <div v-if="!race.intro" class="empty">暂无班级介绍</div>
    </div>

    <race-btn
      :check="enrollCheck"
      :race="race"
      @share="mask=true"
    />
    <!-- <goto-home /> -->

    <van-popup v-model="popupShow" position="bottom" :overlay="true">
      <div class="race_detail_popup">
        <van-icon class="close" name="close" @click="popupShow=false" />
        <div class="panel1">
          <img class="panel1_cover" object-fit="cover" v-lazy="race.cover_url">
          <div>
            <div class="panel1_title">{{race.name}}</div>
            <div class="panel1_price">¥{{selectdPrice}}</div>
          </div>
        </div>
        <div class="panel2">
          <div class="panel2_row">
            <div class="panel2_row_title">距离：</div>
            <van-tag
              v-for="(rule, index) in race.rules" :key="index"
              :plain="!isSelectedRule(rule)"
              type="danger"
              size="large"
              :text-color="isSelectedRule(rule) ? '#fff': '#323233'"
              class="panel2_row_tag" @click="onSelectRule(rule)">{{rule.distance}}km</van-tag>
          </div>
        </div>

        <bottom-btn class="bgwhite select-race" title="立即加入" :fixed="false" @click.native="gotoSave" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { NavBar, Popup, Icon, Tag, Toast } from 'vant'
import RaceBtn from './components/RaceBtn'
import BottomBtn from '@/components/BottomBtn'
import GotoHome from '@/components/GotoHome'
import { raceFullInfo, checkEnrolRecord } from '@/api/race'

export default {
  name: 'clazz',
  components: {
    [NavBar.name]: NavBar,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    RaceBtn,
    BottomBtn,
    GotoHome
  },
  data () {
    return {
      isLoaded: false,
      active: 0,
      popupShow: false,
      mask: false,
      show: false,
      enrollCheck: null,
      race: null,
      selectdRule: null
    }
  },
  computed: {
    ...mapGetters([
      'username'
    ]),
    selectdPrice () {
      if (!this.selectdRule) {
        let minPrice = this.race.rules[0].price
        this.race.rules.map((item) => {
          if (item.price < minPrice) {
            minPrice = item.price
          }
        })
        return minPrice
      }
      return this.selectdRule.price
    }
  },
  created () {
    let raceId = this.$route.params.race_id || ''
    this.getRaceInfo(raceId)
  },
  methods: {
    async getRaceInfo (raceId) {
      let response = await raceFullInfo(raceId)
      this.race = response.data
      if (this.race.rules.length === 1) {
        this.selectdRule = this.race.rules[0]
      }
      if (this.username) {
        await this.checkEnroll()
      }
      this.isLoaded = true
    },
    async checkEnroll () {
      let response = await checkEnrolRecord(this.race.id)
      this.enrollCheck = response.data
    },
    distanceList (rules) {
      return rules.map((r) => `${r.distance}公里`).join(',')
    },
    fatherMethod () {
      if (this.race.rules.length === 1) {
        if (!this.selectdRule) {
          Toast('请选择距离')
          return
        }
        this.$router.push(`/race/${this.race.id}/profile?rule=${this.selectdRule.id}`)
      } else {
        this.popupShow = true
      }
    },
    onSelectRule (rule) {
      this.selectdRule = rule
    },
    isSelectedRule (rule) {
      return this.selectdRule && this.selectdRule.id === rule.id
    },
    gotoSave () {
      if (!this.selectdRule) {
        Toast('请选择距离')
        return
      }
      this.$router.push(`/race/${this.race.id}/profile?rule=${this.selectdRule.id}`)
    },
    backToExplore () {
      this.$router.back()
      // this.$router.push('/explore')
    }
  }
}
</script>

<style scoped lang="scss">
.race_detail_popup {
  position: relative;
  padding: 30px;
  color: #323233;
  font-size: 28px;
  .close {
    font-size: 44px;
    color: #6a6a6a;
    position: absolute;
    right: 30px;
    top: 30px;
  }
  .panel1 {
    display: flex;
    font-size: 30px;
    padding-bottom: 25px;
    border-bottom: 2px solid #ebedf0;
    .panel1_cover {
      width: 120px;
      height: 120px;
      margin-right: 30px;
    }
    .panel1_title {
      margin-top: 10px;
    }
    .panel1_price {
      color: #f5222d;
      margin-top: 10px;
    }
  }
  .panel2 {
    .panel2_row {
      .panel2_row_title {
        padding: 20px 0;
      }
      .panel2_row_tag {
        margin-right: 20px;
      }
    }
  }
  .select-race {
    margin-top: 80px;
  }
}
.race {
  // background-color: #f8f8f8;
  .headimg {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  .header {
    .cover {
      width: 750px;
      height: 375px;
      object-fit: cover;
    }
    .info {
      padding: 25px 25px 0 25px;
      .title {
        font-size: 40px;
        font-weight: bold;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .btn {
          font-size: 26px;
          width: 135px;
          height: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          border: 1PX solid #ebedf0;
          border-radius: 12px;
          background-color: #f5222d;
        }
      }
      .subinfo {
        font-size: 26px;
        color: #9c9c9c;
        margin-top: 10px;
      }
    }
  }
  .race_detail {
    font-weight: 500;
    font-size: 30px;
    color: #323233;
    padding-left: 30px;
    padding: 20px 0 20px 30px;
    margin-top: 20px;
    border-top: 1px solid rgb(229, 225, 225);
    border-bottom: 1px solid rgb(229, 225, 225);
  }
  .render-html {
    font-size: 28px;
  }
  .clazz_part {
    padding: 20px 25px 0 25px;
    margin-bottom: 100px;
    .header {
      font-size: 34px;
    }
    .content {
      font-size: 28px;
      padding: 25px 0;
    }
  }
  .clazz_rule {
    .index {
      display: inline-block;
      width: 30px;
      text-align: center;
    }
    .detail {
      color: #8f8e8e;
      padding-left: 20px;
      .item {
        padding-bottom: 2px;
      }
    }
  }
  .clazz_leader {
    padding: 25px;
    .leader_header {
      display: flex;
      align-items: center;
      font-size: 30px;
      color: #5a728e;
      .headimg {
        width: 90px;
        height: 90px;
        margin-right: 20px;
      }
    }
    .leader_intro {
      margin-left: 110px;
      margin-top: 5px;
      font-size: 26px;
    }
  }
  .empty {
    justify-content: flex-start;
  }
  .hg_cell__value {
    color: #f5222d;
  }
  .mask {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.6;
    z-index: 999;
    img {
      position: fixed;
      width: 550px;
      right: 0;
    }
  }
  .weixin_contract {
    padding: 30px 0;
    text-align: center;
  }
}
</style>
